import { type ContractLexicalContent } from '@/features/contract/contract-lexical-editor.tsx'

export const EMPTY_CONTENT: ContractLexicalContent = {
  root: {
    children: [{ children: [], direction: null, format: '', indent: 0, type: 'paragraph', version: 1 }],
    direction: null,
    format: '',
    indent: 0,
    type: 'root',
    version: 1
  }
}
